// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"9":"b7f0d588","448":"dd76d78a","620":"249dc46d","671":"97d21888","686":"ccbadcfe","926":"af02940b"}[chunkId] + ".css";
};